import React, { useState, useContext } from 'react'
import { notify } from '@/_helpers'
import { API, ViewHeader, Card, Submit, Select, TextArea } from '@enkla-gui'
import { useForm } from 'react-hook-form'
import { UserContext } from '@/App'

const TYPES = [
  { key: 'Fråga', value: 'Fråga', icon: 'fa-comment', desc: 'Ställ en fråga om systemet' },
  { key: 'Funktionsförfrågan', value: 'Funktionsförfrågan', icon: 'fa-lightbulb', desc: 'Föreslå ny funktionalitet' },
  { key: 'Förbättringsförslag', value: 'Förbättringsförslag', icon: 'fa-magic', desc: 'Föreslå förbättringar' },
  { key: 'Felanmälan', value: 'Felanmälan', icon: 'fa-bug', desc: 'Rapportera ett problem' },
]

export default function HelpContact() {
  const { register, handleSubmit, setValue, watch, reset } = useForm()
  const [sending, setSending] = useState(false)
  const [error, setError] = useState(false)
  const { user } = useContext(UserContext)

  const send = data => {
    setSending(true)
    API.post('api/billable/help', data)
      .then(res => {
        notify.alert(`${data.type} skickad.`, `Vi kommer att svara på ditt meddelande via e-post (${user.email})`)
        setSending(false)
        reset({ type: 'Fråga', body: '', reproduce: '' })
      })
      .catch(([err, res]) => {
        setError({ message: res.message, data: res.data })
        setSending(false)
      })
  }

  const selectedType = TYPES.find(t => t.key === watch('type')) || TYPES[0]

  return (
    <>
      <ViewHeader icon='fa-info-circle' title='Hjälp' subtitle='Kontakta oss' />

      <div class='contact-hero'>
        <Card>
          <div class='contact-hero-content'>
            <div class='contact-hero-icon'>
              <i class='fas fa-paper-plane' />
            </div>
            <div class='contact-hero-text'>
              <h2>Kontakta oss</h2>
              <p>
                Har du en fråga, förslag eller vill rapportera ett problem? Fyll i formuläret nedan
                så återkommer vi via e-post till <strong>{user.email}</strong>.
              </p>
            </div>
          </div>
        </Card>
      </div>

      <div class='contact-info-cards'>
        <a href='/#!/help/faq' class='contact-info-card'>
          <div class='contact-info-icon contact-info-teal'>
            <i class='fas fa-question-circle' />
          </div>
          <div class='contact-info-text'>
            <span class='contact-info-value'>Vanliga frågor</span>
            <span class='contact-info-label'>Hitta svar direkt i vår FAQ</span>
          </div>
        </a>
        <div class='contact-info-card'>
          <div class='contact-info-icon contact-info-blue'>
            <i class='fas fa-envelope' />
          </div>
          <div class='contact-info-text'>
            <span class='contact-info-value'>E-post</span>
            <span class='contact-info-label'>kontakt@enklafastigheter.se</span>
          </div>
        </div>
        <div class='contact-info-card'>
          <div class='contact-info-icon contact-info-purple'>
            <i class='fas fa-clock' />
          </div>
          <div class='contact-info-text'>
            <span class='contact-info-value'>Svarstid</span>
            <span class='contact-info-label'>Vanligtvis inom 24 timmar</span>
          </div>
        </div>
      </div>

      <Card
        buttons={{
          footer: [<Submit onSubmit={handleSubmit(send)} text='Skicka meddelande' sending={sending} />]
        }}>

        <div class='contact-type-grid'>
          {TYPES.map(t => (
            <div
              key={t.key}
              class={`contact-type-option ${selectedType.key === t.key ? 'contact-type-active' : ''}`}
              onClick={() => setValue('type', t.key)}>
              <i class={`fas ${t.icon}`} />
              <span class='contact-type-label'>{t.key}</span>
              <span class='contact-type-desc'>{t.desc}</span>
            </div>
          ))}
        </div>
        <input type='hidden' {...register('type', { required: true })} value={selectedType.key} />

        <div class='row mb-3'>
          <TextArea controls={{ register }} name='body' options={{ required: true }} label='Meddelande' error={error} />
        </div>
        {selectedType.key === 'Felanmälan' && (
          <div class='row mb-3'>
            <TextArea
              controls={{ register }}
              name='reproduce'
              options={{ required: true }}
              label='Beskriv steg för steg vad du har försökt göra och vad som hänt'
              error={error}
            />
          </div>
        )}
      </Card>
    </>
  )
}
